<template>
  <div class="books-details">
    <div class="content-box2">
      <p class="box-title">审核资质中</p>
      <div class="box2-cards">
        <el-icon><Warning /></el-icon>
        <div class="box-p">
          <p>资质审核中</p>
          <P>查询码：{{ props.stepInfo.query_code }}</P>
          <p>
            已申请：
            {{ props.stepInfo.days }}天
          </p>
          <p>
            申请时间：
            {{ dayjs(props.stepInfo.create_time * 1000).format("YYYY-MM-DD") }}
          </p>
          <p>当前状态：{{ props.stepInfo.status_text }}</p>
          <p>
            预计领证日期：
            {{ dayjs(props.stepInfo.grant_time * 1000).format("YYYY-MM-DD") }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from "vue-router";

import { reactive, computed } from "vue";
// import { ElMessage } from 'element-plus'
import { ComponentSize, FormInstance, FormRules } from "element-plus";

import {
  Delete,
  Download,
  Plus,
  ZoomIn,
  Warning,
} from "@element-plus/icons-vue";

import { UploadFile } from "element-plus";

import dayjs from "dayjs";

const router = useRouter();

const props = defineProps({
  stepInfo: {
    type: Object,
    default: () => {
      return {};
    },
  },
});

// const props = defineProps({
//   path: {
//     type: String,
//     // default: "",
//   },
//   queryCodeObj: {
//     type: Object,
//     default: () => {
//       return {};
//     },
//   },
// });

// const submitForm = async (formEl: FormInstance | undefined) => {
//   if (!formEl) return
//   await formEl.validate((valid, fields) => {
//     if (valid) {
//       console.log('submit!')
//     } else {
//       console.log('error submit!', fields)
//     }
//   })
// }

// const resetForm = (formEl: FormInstance | undefined) => {
//   if (!formEl) return
//   formEl.resetFields()
// }

// const options = Array.from({ length: 10000 }).map((_, idx) => ({
//   value: `${idx + 1}`,
//   label: `${idx + 1}`,
// }))

// const handleRemove = (file) => {
//   console.log(file)
// }

// const handlePictureCardPreview = (file) => {
//   dialogImageUrl.value = file.url!
//   dialogVisible.value = true
// }

// const handleDownload = (file) => {
//   console.log(file)
// }
</script>

<style scoped lang="scss">
.books-details {
  background-color: #f9f9f9;
  overflow: hidden;
  // border: 1px solid red;
  padding-bottom: 40px; //距离bottomBar的距离

  
  //////内容 2 ——————资质审核中  ////////////////////////////////////
  .content-box2 {
    width: 343px;
    height: 451px;
    margin: 0 auto;
    // padding: 30px;
    border-radius: 8px;
    // border: 1px solid red;
    background-color: #ffffff;
    // border-bottom:1px solid  #dcdee2;
    overflow: hidden;
    // margin-top: 16px;
     .box-title {
      font-size: 18px;
      font-weight: 700;
      color: #333333;
      margin: 16px;
    }
    .box2-cards {
      width: 305px;
      height: 192px;
      border-radius: 8px;
      margin: 0 auto;
      margin-top: 76px;
      border: 1px solid #91d5ff;
      background-color: #e6f7ff;
      display: flex;
      padding: 25px 0px 0px 27px;

      //////图标
      :deep(.el-icon) {
        font-size: 30px;
        color: #1890ff;
      }
      .box-p {
        margin-left: 11px;
        p {
          font-size: 14px;
          font-weight: 400;
          color: #000000a6;
          line-height: 22px;
        }
        p:nth-of-type(1) {
          font-size: 24px;
          font-weight: 700;
          color: #000000d9;
          margin-top: -2px;
          line-height: 32px;
        }
        p:nth-of-type(2) {
          margin-top: 10px;
        }
      }
    }
  }
}
</style>